import React, { useState, useEffect } from "react"; 
import { DNA } from "react-loader-spinner"; 

const Loader = ({ size = 150, loading = true, cssOverride = {} }) => { 
  const [isLoading, setIsLoading] = useState(loading);

  useEffect(() => { 
    setIsLoading(loading); 
  }, [loading]);

  if (!isLoading) { 
    return null; 
  }

  return ( 
    <div
      className="flex justify-center items-center min-h-screen bg-gray-100"
      style={cssOverride}
    >
      <DNA
        visible={isLoading}
        height={`${size}px`}  
        width={`${size}px`}   
        ariaLabel="dna-loading"
        wrapperStyle={{}}
        wrapperClass="dna-wrapper"
      />
    </div>
  ); 
};

export default Loader;
